import { Component, OnInit } from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { TraningsAndExamsHandlerComponent } from './tranings-and-exams.handler';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';

@Component({
  selector: 'sym-tranings-and-exams',
  templateUrl: './tranings-and-exams.component.html',
  styleUrls: ['./tranings-and-exams.component.scss'],
})
export class TraningsAndExamsComponent extends TraningsAndExamsHandlerComponent implements OnInit {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }
}
